module.exports = __webpack_public_path__ + "img/tabbar3-1.b2b85f31.svg";